import { useEffect, useState } from "react";
import { FormattedMessage as FM } from "react-intl";

import proxy from "api/proxy";
import { HOME_CARDS } from "../constants";

async function fetchCounts() {
  const results = await Promise.all(
    HOME_CARDS.map((card) => proxy.searchCount(card.model, card.domain)),
  );
  const counts = {};
  HOME_CARDS.forEach((card, idx) => {
    const { data, error } = results[idx] || {};
    counts[card.id] = error ? null : data;
  });
  return counts;
}

function MelhousHome({ onOpen }) {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    let cancelled = false;
    async function load() {
      const result = await fetchCounts();
      if (!cancelled) setCounts(result);
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 p-3 lg:p-4">
      {HOME_CARDS.map(({ id, label, view, Icon }) => (
        <button
          key={id}
          type="button"
          onClick={() => onOpen(view)}
          className="flex items-center gap-4 rounded-lg border border-neutral-200 bg-white p-4 text-left shadow-sm hover:border-sky-900 hover:shadow-md transition"
        >
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-sky-950 text-white">
            <Icon width={22} className="fill-current" />
          </span>
          <span className="flex flex-col">
            <span className="text-3xl font-semibold text-neutral-800">
              {counts[id] ?? "-"}
            </span>
            <span className="text-sm text-neutral-500">
              <FM id={label} />
            </span>
          </span>
        </button>
      ))}
    </div>
  );
}

export default MelhousHome;
